import WebServiceRequest from '../Api/WebServiceRequest'
class PaymentReceiptGetAllRequest extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setTag('PaymentReceipt/GetList')
  }
  setParams(data) {
    super.setRequestParamDataObj(data)
  }
}
class PaymentReceiptCreateUserRequest extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setTag('PaymentReceipt/CreateUser')
  }
  setParams(data) {
    super.setRequestParam(data)
  }
}
class PaymentReceiptAccountConfirmeRequest extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setTag('PaymentReceipt/AcountantConfirme')
  }
  setParams(data) {
    super.setRequestParam(data)
  }
}
class PaymentReceiptDeleteRequest extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setTag('PaymentReceipt/Delete')
  }
  setParams(data) {
    super.setRequestParam(data)
  }
}

class PaymentReceiptUpdatePaymentReceiptDetaileRequest extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setTag('PaymentReceipt/UpdatePaymentReceiptDetaile')
  }
  setParams(data) {
    super.setRequestParamDataObj(data)
  }
}

class PaymentReceiptConfirmeRequest extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setTag('PaymentReceipt/Confirme')
  }
  setParams(data) {
    super.setRequestParam(data)
  }
}
class PaymentReceiptRejectRequest extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setTag('PaymentReceipt/Reject')
  }
  setParams(data) {
    super.setRequestParamDataObj(data)
  }
}
class PaymentReceiptGetByIdRequest extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setTag('PaymentReceipt/GetById')
  }
  setParams(data) {
    super.setRequestParam(data)
  }
}
class PaymentReceiptGetListRequest extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setTag('PaymentReceipt/GetList')
  }
}
class PaymentReceiptExportToExcelRequest extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setTag('PaymentReceipt/ExportToExcel')
  }
}

class PaymentReceiptLogRequest extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setTag('PaymentReceiptLog/GetList')
  }
  setParams(data){
    super.setRequestParamDataObj(data)
  }
}

export {
  PaymentReceiptGetAllRequest,
  PaymentReceiptCreateUserRequest,
  PaymentReceiptAccountConfirmeRequest,
  PaymentReceiptDeleteRequest,
  PaymentReceiptConfirmeRequest,
  PaymentReceiptRejectRequest,
  PaymentReceiptGetByIdRequest,
  PaymentReceiptGetListRequest,
  PaymentReceiptExportToExcelRequest,
  PaymentReceiptLogRequest,
  PaymentReceiptUpdatePaymentReceiptDetaileRequest
}
